import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-view-single-feature-component',
  templateUrl: './view-single-feature-component.component.html',
  styleUrls: ['./view-single-feature-component.component.css']
})
export class ViewSingleFeatureComponentComponent implements OnInit {
  feature: any;

  constructor(
    public dialogRef: MatDialogRef<ViewSingleFeatureComponentComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.feature = data.feature;
    // this.feature.imageURL = environment.baseURL + "app/download" + this.reportDetails.imageURL;
  }

  ngOnInit(): void {
  }

}
